import React from 'react'
import styled, { css } from 'styled-components'
import { useMediaQuery } from 'react-responsive'

import Box from '@components/Box'
import { md, xl } from '@styles/variables/breakpoints'
import { above } from '@styles/mixins/breakpoints'

import { ILines } from './icons'

const SBackground = styled(Box)`
  position: absolute;
  top: 50%;
  left: 398px;
  transform: translate(-50%, -50%);
  z-index: 0;
  margin-left: -26px;
  height: 304px;
  width: 289px;

  ${above('md')(css`
    left: 50%;
    margin-left: 0;
    padding: 0 40px;
    height: 332px;
    width: 100%;
  `)}

  ${above('xl')(css`
    height: 287px;
    width: 574px;
    padding: 0;
  `)}
`

interface IProps {
  lines: ILines
}

const Background: React.FC<IProps> = ({ lines }) => {
  const isXl = useMediaQuery({ minWidth: xl })
  const isMd = useMediaQuery({ minWidth: md, maxWidth: xl - 1 })
  const isSm = useMediaQuery({ maxWidth: md - 1 })

  return (
    <SBackground display="flex" flexDirection={{ _: 'column', md: 'row', xl: 'column' }} justifyContent="space-between">
      {isSm && (
        <>
          {lines.sm.line}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Box mb="31px">{lines.sm.left}</Box>
              {lines.sm.right}
            </Box>
            <Box>
              <Box mb="31px">{lines.sm.right}</Box>
              {lines.sm.left}
            </Box>
          </Box>
          {lines.sm.line}
        </>
      )}
      {isMd && (
        <>
          {lines.md.line}
          <Box display="flex" height="100%" justifyContent="space-between" flexDirection="column" minWidth="58%">
            <Box display="flex" justifyContent="space-between">
              {lines.md.right}
              {lines.md.left}
            </Box>
            <Box display="flex" justifyContent="space-between">
              {lines.md.left}
              {lines.md.right}
            </Box>
          </Box>
          {lines.md.line}
        </>
      )}
      {isXl && (
        <>
          {lines.lg.line}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box>
              <Box mb="49px">{lines.lg.left}</Box>
              {lines.lg.right}
            </Box>
            <Box>
              <Box mb="49px">{lines.lg.right}</Box>
              {lines.lg.left}
            </Box>
          </Box>
          {lines.lg.line}
        </>
      )}
    </SBackground>
  )
}

export default Background
